export function script(userValidReg: RegExp) {
  const updateHtmlUserStatus = () => {
    const cookieDecoded = document.cookie.includes('%')
      ? decodeURIComponent(document.cookie)
      : document.cookie
    const isUserValid = userValidReg.test(cookieDecoded)
    document.documentElement.dataset.userStatus = isUserValid
      ? 'valid'
      : 'vague'
  }

  updateHtmlUserStatus()
  window.updateHtmlUserStatus = updateHtmlUserStatus
}
